export const DEFAULT_IMAGE_ICON_SIZE = 33;

export const DEFAULT_IMAGE_SIZE = 60;

export const NUMBER_OF_OPTIONS_TO_SHOW_BEFORE_COLLAPSE = 2;
export const NUMBER_OF_PROJECTIONS_TO_SHOW_BEFORE_COLLAPSE = 2;
export const MAX_DESCRIPTION_LINE_LENGTH = 500;
export const MAX_MODIFIER_LENGTH = 485;

export const SPECS = {
  CheckoutExcludeGoogleAutoCompleteOld: 'specs.stores.CheckoutExcludeGoogleAutoComplete',
  CheckoutExcludeGoogleAutoComplete: 'specs.ecom.CheckoutExcludeGoogleAutoComplete',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  AlwaysSendCurrencyHeader: 'specs.ecom.AlwaysSendCurrencyHeader',
  SupportManualPaymentsOnPaymentRequest: 'specs.ecom.SupportManualPaymentsOnPaymentRequest',
  ShowVoidedErrorMessage: 'specs.ecom.ShowVoidedErrorMessage',
  HideMissingLineItemImagesInPaymentRequest: 'specs.ecom.HideMissingLineItemImagesInPaymentRequest',
  ErrorHandlerOnStorefrontSdk: 'specs.ecom.ErrorHandlerOnStorefrontSdk',
  UseLayoutEffectInCheckout: 'specs.ecom.UseLayoutEffectInCheckout',
  MigrateAddressFormToV2: 'specs.ecom.MigrateAddressFormToV2',
  CallCartV2FromCheckout: 'specs.ecom.CallCartV2FromCheckout',
  AddCartServiceToContext: 'specs.ecom.AddCartServiceToContext',
  ExpressLoaderInCheckout: 'specs.ecom.ExpressLoaderInCheckout',
  DeliveryOptionsSetFirstAsDefault: 'specs.ecom.deliveryOptionsSetFirstAsDefault',
  UseMarketingConsentApiForSubscription: 'specs.ecom.UseMarketingConsentApiForSubscription',
  StopSendingOriginInCheckoutUrl: 'specs.ecom.StopSendingOriginInCheckoutUrl',
  SupportDynamicBillingFieldsCheckout: 'specs.ecom.SupportDynamicBillingFieldsCheckout',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  ShouldRenderStepContentWithCallback: 'specs.ecom.ShouldRenderStepContentWithCallback',
  CallCartV2FromCartComponents: 'specs.ecom.CallCartV2FromCartComponents',
  CheckoutUIRevampOrderSummary: 'specs.ecom.CheckoutUIRevampOrderSummary',
  AddExemptTextToTaxNameWhenPartiallyExempt: 'specs.ecom.AddExemptTextToTaxNameWhenPartiallyExempt',
  CheckoutHeaderAdditionalCustomizationsCheckout: 'specs.ecom.CheckoutHeaderAdditionalCustomizationsCheckout',
  ShowCheckoutOnEditorPreview: 'specs.ecom.ShowCheckoutOnEditorPreview',
  CheckoutHeaderContinueBrowsingDisplayCheckout: 'specs.ecom.CheckoutHeaderContinueBrowsingDisplayCheckout',
  CallShowPaymentErrorModalAfterValidation: 'specs.ecom.CallShowPaymentErrorModalAfterValidation',
  CouponAlignmentInCartAndCheckout: 'specs.ecom.CouponAlignmentInCartAndCheckout',
  RevampDiscountsInCartAndCheckout: 'specs.ecom.RevampDiscountsInCartAndCheckout',
  ShowCheckoutPoliciesPage: 'specs.ecom.ShowCheckoutPoliciesPage',
  SendPaymentTokenUndefinedFallback: 'specs.ecom.SendPaymentTokenUndefinedFallback',
  ReplaceEcomAddressComponentForAllUsersAudience: 'specs.forms.ReplaceEcomAddressComponentForAllUsersAudience',
  ReplaceEcomAddressComponent: 'specs.forms.ReplaceEcomAddressComponent',
  HidePointerOnNotClickableHeader: 'specs.ecom.HidePointerOnNotClickableHeader',
  AddCheckoutCountryToDeliveryCountries: 'specs.ecom.AddCheckoutCountryToDeliveryCountries',
  UseIsMobileForOneColumnView: 'specs.ecom.UseIsMobileForOneColumnView',
  FixImageDimensionsOnCart: 'specs.ecom.FixImageDimensionsOnCart',
  HandleCheckoutErrorStates: 'specs.ecom.HandleCheckoutErrorStates',
  overrideDeliveryCountriesOnlyOnShippingFlow: 'specs.ecom.overrideDeliveryCountriesOnlyOnShippingFlow',
  UpdateCartIconsSVGViewer: 'specs.ecom.UpdateCartIconsSVGViewer',
  VerifyCountryBeforeSkippingCustomerDetailsStep: 'specs.ecom.VerifyCountryBeforeSkippingCustomerDetailsStep',
  RegisterWebMcpTools: 'specs.ecom.RegisterWebMcpTools',
};

export const A11yIds = {
  SummarySection: 'summary-section',
};

export const MANDATORY_FIELDS_HIDDEN = [
  'countryCode',
  'state',
  'email',
  'firstName',
  'lastName',
  'street',
  'houseNumber',
  'address',
  'city',
  'zipCode',
  'phone',
];

export const HOLDER_ID_FIELD = 'holderId';
export const POLICIES_PATH = 'policies';
